import ISignUpRepository from "./ISignUpRepository";
import IServiceCallRepository from "./IServiceCallRepository";
import IServiceCallNoteRepository from "./IServiceCallNoteRepository";
import IContactRepository from "./IContactRepository";
import ICompanyRepository from "./ICompanyRepository";
import IAttachmentRepository from "./IAttachmentRepository";
import IIntegrationRepository from "./IIntegrationRepository";
import ISupportTicketCategoryRepository from "./ISupportTicketCategoryRepository";
import IAPICredentialsRepository from "./IAPICredentialsRepository";
import IConfirmationCodeRepository from "./IConfirmationCodeRepo";
import INotificationRepository from "./INotificationRepository";

interface IServiceFactory<TService> {
  (): Promise<TService>;
}

async function getService<TService>(name: keyof Services, factory: IServiceFactory<TService>): Promise<TService> {
  if (!window.PartnerPortal.ServiceCache) {
    window.PartnerPortal.ServiceCache = {};
  }
  const cache = window.PartnerPortal.ServiceCache;

  if (!cache[name]) {
    cache[name] = await factory();
  }
  return cache[name];
}

export default class Services {
  async ServiceCallRepository(): Promise<IServiceCallRepository> {
    return await getService<IServiceCallRepository>("ServiceCallRepository", async () => {
      return new (await import("./prod/ServiceCallRepository")).default();
    });
  }
  async ServiceCallNoteRepository(): Promise<IServiceCallNoteRepository> {
    return await getService<IServiceCallNoteRepository>("ServiceCallNoteRepository", async () => {
      return new (await import("./prod/ServiceCallNoteRepository")).default();
    });
  }
  async SignUpRepository(): Promise<ISignUpRepository> {
    return await getService<ISignUpRepository>("SignUpRepository", async () => {
      return new (await import("./prod/SignUpRepository")).default();
    });
  }
  async ContactRepository(): Promise<IContactRepository> {
    return await getService<IContactRepository>("ContactRepository", async () => {
      return new (await import("./prod/ContactRepository")).default();
    });
  }
  async CompanyRepository(): Promise<ICompanyRepository> {
    return await getService<ICompanyRepository>("CompanyRepository", async () => {
      return new (await import("./prod/CompanyRepository")).default();
    });
  }
  async AttachmentRepository(): Promise<IAttachmentRepository> {
    return await getService<IAttachmentRepository>("AttachmentRepository", async () => {
      return new (await import("./prod/AttachmentRepository")).default();
    });
  }
  async IntegrationRepository(): Promise<IIntegrationRepository> {
    return await getService<IIntegrationRepository>("IntegrationRepository", async () => {
      return new (await import("./prod/IntegrationRepository")).default();
    });
  }
  async SupportTicketCategoryRepository(): Promise<ISupportTicketCategoryRepository> {
    return await getService<ISupportTicketCategoryRepository>("SupportTicketCategoryRepository", async () => {
      return new (await import("./prod/SupportTicketCategoryRepository")).default();
    });
  }
  async APICredentialsRepository(): Promise<IAPICredentialsRepository> {
    return await getService<IAPICredentialsRepository>("APICredentialsRepository", async () => {
      return new (await import("./prod/APICredentialsRepository")).default();
    });
  }
  async ConfirmationCodeRepository(): Promise<IConfirmationCodeRepository> {
    return await getService<IConfirmationCodeRepository>("ConfirmationCodeRepository", async () => {
      return new (await import("./prod/ConfirmationCodeRepository")).default();
    });
  }
  async NotificationRepository(): Promise<INotificationRepository> {
    return await getService<INotificationRepository>("NotificationRepository", async () => {
      return new (await import("./prod/NotificationRepository")).default();
    });
  }
}
